import React from 'react';
import { Edit, SaveButton, Toolbar, ToolbarProps } from 'react-admin';
import { useMediaQuery } from '@mui/material';
import HeaderTitle from '../../Shared/HeaderTitle/HeaderTitle';
import ResourceDetailTopToolbar from '../../Shared/ResourceDetailTopToolbar/ResourceDetailTopToolbar';
import { ScheduledMessageForm } from '../components/ScheduledMessageForm';

const EditActions: React.FC<ToolbarProps> = (props) => (
  <Toolbar
    {...props}
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0 24px 0 24px !important',
      position: 'sticky',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 2,
    }}
  >
    <SaveButton />
  </Toolbar>
);

const ScheduledMessageEdit: React.FC = (props) => {
  const isSmallDevice = useMediaQuery((theme: any) =>
    theme.breakpoints.down('sm')
  );

  return (
    <Edit
      mutationMode="pessimistic"
      actions={
        <ResourceDetailTopToolbar resource="Scheduled Message" hasBackButton />
      }
      title={<HeaderTitle />}
      {...(isSmallDevice && {
        sx: {
          marginBottom: '2rem',
          paddingLeft: '1rem',
          '& .MuiPaper-root': {
            border: 'none',
            boxShadow: 'none',
            height: 'auto',
          },
          '& .MuiCardContent-root': {
            padding: 0,
          },
        },
      })}
      {...props}
    >
      <ScheduledMessageForm toolbar={<EditActions />} />
    </Edit>
  );
};

export default ScheduledMessageEdit;
